import { Map, List, fromJS } from 'immutable';
import { is } from 'ramda';
import storage from '@synergycms_core/utils/storage';
import actions from '../../actions';
import { createReservationRequest } from './reservationUtils';
import {
  AD_BOARD,
  AD_BOARD_BUFFET,
  SA_BOARD,
  SERVICE_TYPE_PER_PERSON,
  SERVICE_TYPE_PER_PERSON_NIGHT
} from '../../../config/constants';

export default {
  // blocks must be immutable
  INITIALIZE: (blocks = false, persistLoyalty) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'current_hotel']);
      const hotel = store.getIn(['hotels', hotelId]);

      let corporateStore = store.getIn(['customer', 'corporate']) || Map();
      if (typeof corporateStore === 'string' || corporateStore === null) {
        corporateStore = Map();
      }

      const companyCode = corporateStore.get('afiliado', false) || corporateStore.get('avail_code', false) || false;
      const loyaltyUserId = corporateStore.get('tipo_perfil', false) === '2' && corporateStore.get('id_empresa', false);
      const companyUserId = corporateStore.get('company_user_id', false);

      const currencyCode = hotel.getIn(['currency', 'code']);
      const clientCurrencyCode = store.getIn(['customer', 'current_currency']);

      const queryParams = store.getIn(['hotels', hotelId, 'params', 'params']);

      const syn2LoyaltyUser = store.getIn(['customer', 'loyalty', 'user'], false);
      let loyalty = null;

      if (persistLoyalty) {
        loyalty = store.getIn(['customer', 'reservation_request', 'loyalty'], null);
      } else if (syn2LoyaltyUser && syn2LoyaltyUser.get('email')) {
        loyalty = Map({
          email: syn2LoyaltyUser?.get('email'),
          user_id: syn2LoyaltyUser?.get('user_id'),
          token: syn2LoyaltyUser?.get('token'),
          selected: null
        });
      }

      const reservationRequest = createReservationRequest(
        hotelId, //hotelId
        hotel.get('code'), //hotelCode
        hotel.get('name'), // hotelName
        queryParams.get('date'), // checkinDate
        queryParams.get('stay_length'), // stayLength
        queryParams.get('occups'), // occups
        currencyCode, // currencyCode
        clientCurrencyCode, // clientCurrencyCode
        store.getIn(['customer', 'transaction_id']), // transactionId
        store.getIn(['customer', 'country', 'code']), // countryCode
        store.getIn(['customer', 'client_ip']), // clientIp
        (!companyCode && queryParams.get('avail_code')) || null, // refererCode
        queryParams.get('promotion_code') || null, // promotionCode
        queryParams.get('gift_voucher') || null, // giftVoucher
        queryParams.get('company_id') || null,
        queryParams.get('referer_code') || null,
        companyCode || null,
        companyUserId || null,
        loyaltyUserId || null,
        loyalty || null,
        blocks || null,
        store.get('system', false)
      );

      storage.set('last_reservation_request', reservationRequest.toJS());
      return reservationRequest;
    };
  },
  SET: (newReservationRequest) => {
    return (dispatch, getState) => {
      if (typeof newReservationRequest === 'function') {
        newReservationRequest = newReservationRequest(getState().getIn(['customer', 'reservation_request']));
      }
      const reservationRequest = storage.get('last_reservation_request');
      if(reservationRequest) {
        storage.set('last_reservation_request', Object.assign(reservationRequest, newReservationRequest.toJS()));
      }
      return newReservationRequest;
    };
  },
  SET_BLOCK: (block, idx) => {
    return (dispatch, getState) => {
      const currentBlocks = getState().getIn(['customer', 'reservation_request', 'blocks']);

      if (parseInt(block.get('service_id'), 10) > 0) {
        block = block.set('services', List().push(Map({ service_id: block.get('service_id'), price: 0, quantity: 1 })));
      }

      if (!is(List, block.get('services'))) {
        block = block.set('services', List());
      }

      const newBlocks =
        is(Map, block) &&
        block.has('room_id') &&
        block.has('occup_group_id') &&
        block.has('ref_type') &&
        block.has('board_id') &&
        block.has('price') &&
        block.has('price_tax')
          ? currentBlocks.set(idx - 1, block)
          : currentBlocks;

      const reservationRequest = storage.get('last_reservation_request');
      storage.set('last_reservation_request', Object.assign(reservationRequest, { blocks: newBlocks.toJS() }));

      return newBlocks;
    };
  },
  SET_BLOCKS: (bookingBlocks) => {
    return bookingBlocks;
  },
  ADD_SERVICE: (serviceBlocks) => {
    return (dispatch, getState) => {
      const store = getState();
      const newBlocks = store.getIn(['customer', 'reservation_request', 'blocks']).reduce((newBlocks, block) => {
        const service = serviceBlocks.get(block.get('idx'), false);
        let newBlock = block;
        if (service) {
          let services = block.get('services');
          const existingServiceKey = services.findIndex((s) => s.get('service_id') === service.get('service_id'));

          if (existingServiceKey !== -1) {
            services = services.delete(existingServiceKey);
          }
          newBlock = newBlock.set('services', services.push(service));
        }

        return newBlocks.push(newBlock);
      }, List());

      const reservationRequest = storage.get('last_reservation_request');
      storage.set('last_reservation_request', Object.assign(reservationRequest, { blocks: newBlocks.toJS() }));

      return newBlocks;
    };
  },
  ADD_SERVICE_BY_TIME: (serviceBlocks) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'current_hotel']);
      const availServices = store.getIn([
        'availServices',
        hotelId,
        store.getIn(['hotels', hotelId, 'params', 'service_query_params']),
        'response'
      ]);

      const newBlocks = store.getIn(['customer', 'reservation_request', 'blocks']).reduce((newBlocks, block) => {
        const service = serviceBlocks.get(block.get('idx'), false);
        let newBlock = block;

        if (!service) {
          return newBlocks.push(newBlock);
        }

        const serviceInfo = availServices.get('services').find((s) => s.get('id') === service.get('service_id'));
        const serviceType = serviceInfo.get('type').toUpperCase();

        let quantity = 1;
        if ([SERVICE_TYPE_PER_PERSON, SERVICE_TYPE_PER_PERSON_NIGHT].includes(serviceType)) {
          quantity = block.get('adults') + block.get('childs', 0);
        }

        let services = block.get('services');
        const existingServiceKey = services.findIndex((s) => s.get('service_id') === service.get('service_id'));

        if (existingServiceKey !== -1) {
          let newService = services.get(existingServiceKey);
          services = services.delete(existingServiceKey);

          newService = newService
            .set('quantity', newService.get('quantity') + quantity)
            .set('price', newService.get('price') + service.get('price'));

          const serviceDateDay = service.get('dates').first().get('day');
          const serviceDateTime = service.get('dates').first().get('time') || false;

          let dateIdx = null;
          let newDate = null;

          if (serviceDateDay && serviceDateTime) {
            dateIdx = newService
              .get('dates')
              .findIndex((d) => d.get('day') === serviceDateDay && d.get('time') === serviceDateTime);
          } else {
            dateIdx = newService.get('dates').findIndex((d) => d.get('day') === serviceDateDay);
          }

          if (dateIdx !== -1) {
            newDate = Map(newService.getIn(['dates', dateIdx])).set(
              'quantity',
              newService.getIn(['dates', dateIdx, 'quantity']) + quantity
            );
            newService = newService.set('dates', newService.get('dates').set(dateIdx, newDate));
          } else {
            newService = newService.set('dates', newService.get('dates').push(service.get('dates').first()));
          }

          services = services.push(newService);
          newBlock = newBlock.set('services', services);
        } else {
          newBlock = newBlock.set('services', services.push(service));
        }

        return newBlocks.push(newBlock);
      }, List());

      const reservationRequest = storage.get('last_reservation_request');
      storage.set('last_reservation_request', Object.assign(reservationRequest, { blocks: newBlocks.toJS() }));

      return newBlocks;
    };
  },
  REMOVE_SERVICE_BY_TIME: (blockIdx, serviceId, date) => {
    return (dispatch, getState) => {
      const store = getState();
      const newBlocks = store.getIn(['customer', 'reservation_request', 'blocks']).reduce((newBlocks, block) => {
        if (block.get('idx') === blockIdx) {
          let services = block.get('services');
          const service = services.find((s) => s.get('service_id') === serviceId);

          if (!service) {
            return newBlocks.push(block);
          }

          let newService = service;
          let dateIdx = null;
          let newDates = null;

          if (date.get('time', false)) {
            dateIdx = newService
              .get('dates')
              .findIndex((d) => d.get('day') === date.get('day') && d.get('time') === date.get('time'));
          } else {
            dateIdx = newService.get('dates').findIndex((d) => d.get('day') === date.get('day'));
          }

          if (dateIdx !== -1) {
            newDates = newService.get('dates');
            newDates = newDates.delete(dateIdx);
            newService = newService.set('dates', newDates);

            if (!newService.get('dates').size) {
              services = services.delete(services.findIndex((s) => s.get('service_id') === serviceId));
              return newBlocks.push(block.set('services', services));
            } else {
              const serviceIdx = services.findIndex((s) => s.get('service_id') === serviceId);
              services = services.delete(serviceIdx).push(newService);
            }
          }

          return newBlocks.push(block.set('services', services));
        } else {
          return newBlocks.push(block);
        }
      }, List());

      const reservationRequest = storage.get('last_reservation_request');
      storage.set('last_reservation_request', Object.assign(reservationRequest, { blocks: newBlocks.toJS() }));

      return newBlocks;
    };
  },
  SET_SERVICE_QUANTITY: (blockIdx, serviceId, quantity, date) => {
    return (dispatch, getState) => {
      const store = getState();
      const hotelId = store.getIn(['customer', 'current_hotel']);
      const serviceAvailResponse = store.getIn([
        'availServices',
        hotelId,
        store.getIn(['hotels', hotelId, 'params', 'service_query_params']),
        'response'
      ]);
      const servicesInfo = serviceAvailResponse.get('services');

      const newBlocks = store.getIn(['customer', 'reservation_request', 'blocks']).reduce((newBlocks, block) => {
        if (block.get('idx') === blockIdx) {
          let services = block.get('services');
          const service = services.find((s) => s.get('service_id') === serviceId);
          let newService = service;
          let serviceInfo = servicesInfo.find((s) => s.get('id') === serviceId);
          const serviceDayPrices = serviceInfo
            .get('days')
            .reduce((prices, day) => prices.set(day.get('day'), day.get('price')), Map());

          let newDate = null;
          let dateIdx = null;

          if (date.get('time', false)) {
            dateIdx = newService
              .get('dates')
              .findIndex((d) => d.get('day') === date.get('day') && d.get('time') === date.get('time'));
          } else {
            dateIdx = newService.get('dates').findIndex((d) => d.get('day') === date.get('day'));
          }

          if (dateIdx !== -1) {
            newDate = newService.getIn(['dates', dateIdx]).set('quantity', quantity);
            newService = newService.set('dates', newService.get('dates').set(dateIdx, newDate));
          }

          newService = newService.set(
            'quantity',
            newService.get('dates').reduce((quantity, date) => quantity + date.get('quantity'), 0)
          );

          newService = newService.set(
            'price',
            newService.get('dates').reduce((price, date) => {
              const datePrice = serviceDayPrices.get(date.get('day'), 0);
              return price + datePrice * date.get('quantity');
            }, 0)
          );

          services = services.delete(services.findIndex((s) => s.get('service_id') === serviceId)).push(newService);

          return newBlocks.push(block.set('services', services));
        } else {
          return newBlocks.push(block);
        }
      }, List());

      const reservationRequest = storage.get('last_reservation_request');
      storage.set('last_reservation_request', Object.assign(reservationRequest, { blocks: newBlocks.toJS() }));

      return newBlocks;
    };
  },
  REMOVE_SERVICE: (serviceBlocks) => {
    return (dispatch, getState) => {
      const store = getState();
      const newBlocks = store.getIn(['customer', 'reservation_request', 'blocks']).reduce((newBlocks, block) => {
        const service = serviceBlocks.get(block.get('idx'), false);
        let newBlock = block;
        if (service) {
          const services = block.get('services');
          let existingServiceKey = services.findIndex((s) => s.get('service_id') === service.get('service_id'));
          if (existingServiceKey !== -1) {
            newBlock = newBlock.set('services', services.delete(existingServiceKey));
          }
        }

        return newBlocks.push(newBlock);
      }, List());

      const reservationRequest = storage.get('last_reservation_request');
      storage.set('last_reservation_request', Object.assign(reservationRequest, { blocks: newBlocks.toJS() }));

      return newBlocks;
    };
  },
  ADD_ROOM_PREFERENCES: (idx, preferences) => {
    return (dispatch, getState) => {
      const store = getState();

      let reservationRequest = store.getIn(['customer', 'reservation_request']);
      reservationRequest = reservationRequest.setIn(['blocks', idx - 1, 'preferences'], fromJS(preferences));
      storage.set('last_reservation_request', reservationRequest);

      return reservationRequest;
    };
  },
  REFRESH_BLOCKS: (updateBooking) => {
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        const store = getState();
        const reservation = store.getIn(['customer', 'reservation']);
        const requestSource = store.getIn(['customer', 'reservation_request']);
        const hotelId = store.getIn(['customer', 'current_hotel']);
        const usesLoyaltyAvail = reservation.get('loyalty')?.size || requestSource.getIn(['loyalty', 'selected']);
        const avail = store.getIn([
          'avail',
          hotelId,
          store.getIn([
            'hotels',
            hotelId,
            'params',
            usesLoyaltyAvail ? 'loyalty_query_params' : 'query_params'
          ]),
          'response'
        ]);
        let reservationRequest = List();
        let error = false;
        let boardChanged = false;

        reservation.getIn(['blocks']).forEach((block, idx) => {
          const originalBlock = requestSource.getIn(['blocks', idx], Map());
          let blockServiceId = originalBlock.get('service_id', null);
          if (blockServiceId) {
            if (!block.get('services').find((s) => s.get('service_id') === blockServiceId)) {
              blockServiceId = null;
            }
          }
          const roomId = block.get('room_id');
          const roomKey = blockServiceId ? `${roomId}-${blockServiceId}` : roomId;
          const roomAvail = avail.getIn([idx, roomKey], Map());
          let refType = block.get('ref_type');
          let rateId = block.get('rate_id', null);
          let uniqueRefType =
            block.get('unique_ref_type') ||
            (block.get('ref_type') === 'full' ? `${block.get('ref_type')}-${rateId}` : block.get('ref_type'));
          let boardID = block.get('board_id');

          // Si venimos de una SA y la nueva dispo ofrece Desayuno gratuito le cambiamos el regimen al cliente a AD
          if (
            roomAvail.get('free_breakfast', false) === true &&
            roomAvail.getIn(['boards', block.get('board_id'), uniqueRefType, 'board_code'], false) === SA_BOARD
          ) {
            let ADAvail = false;
            roomAvail.getIn(['boards']).forEach((refTypesBoards) => {
              if (!ADAvail) {
                ADAvail = refTypesBoards.find((b) => {
                  if (b.getIn(['board_code']) === AD_BOARD || b.getIn(['board_code']) === AD_BOARD_BUFFET) {
                    boardID = b.get('board_id');
                    boardChanged = true;
                    return true;
                  } else {
                    return false;
                  }
                });
              }
            });
          }

          let rateAvail = roomAvail.getIn(['boards', boardID, uniqueRefType], false);
          if (!rateAvail && refType === 'ref') {
            uniqueRefType = refType = refType === 'ref' ? 'any' : 'ref';
            rateAvail = roomAvail.getIn(['boards', boardID, uniqueRefType], false);
          }

          if (rateAvail) {
            const initial = {
              idx: idx + 1,
              occup_group_id: block.get('occup_group_id'),
              adults: roomAvail.get('adults'),
              childs: roomAvail.get('childs'),
              room_id: block.get('room_id'),
              service_id: blockServiceId || block.get('service_id', null),
              board_id: boardID,
              rate_id: rateId,
              refundable: block.get('refundable'),
              unique_ref_type: uniqueRefType,
              ref_type: refType,
              price: rateAvail.get('price'),
              price_tax: rateAvail.get('price_tax'),
              discount_amount: rateAvail.get('discount_amount'),
              discounts: rateAvail.get('discounts', List()),
              // Compatibilitat Hab + Paquet
              room_board_price: rateAvail.get('room_board_price', rateAvail.get('price')),
              room_board_price_tax: rateAvail.get('room_board_price_tax', rateAvail.get('price_tax')),
              service_price: rateAvail.get('service_price', 0),
              preferences: block.get('preferences', List()),
              services: requestSource.getIn(['blocks', idx, 'services'], List())
            };

            reservationRequest = reservationRequest.push(Map(initial));
          } else {
            error = true;
          }
        });

        if (!error) {
          dispatch(actions.customer.reservationRequest.initialize(reservationRequest, true));
          if (boardChanged) {
            dispatch(actions.customer.reservation.postAsync(updateBooking));
          }
          resolve();
        } else {
          reject(Error({ error: 'parameters do not match' }));
        }
      });
    };
  }
};
